/** 设置一个可以无限向右滚动的gallery  */
function setupScreenAnimate(){
  gsap.registerPlugin(Observer);
  const $list = $('.gallery-hero-scroller-wrapper');
  const $items = $list.find('.gallery-hero-item');
  const $indicatorContainer = $('.gallery-hero-indicators');

  const $leftNav = $('#gallery-hero-thumb-left');
  const $rightNav = $('#gallery-hero-thumb-right');

  //当前index
  let currentIndex = 0;
  // 是否正在动画
  let isAnimating = false;
  let autoPlayTimer = null;
  // 初始总个数
  const totalCount = $items.length;
  

  // 切换
  function switchIndicator(index) {
    // 根据data-index判断激活哪个
    $indicatorContainer.find('.gallery-hero-indicator').removeClass('active');
    $indicatorContainer.find(`.gallery-hero-indicator[data-index="${index}"]`).addClass('active');
  }

  // 切换到下一个
  function switchToNext() {
    if(isAnimating) {
      return;
    }
    const willChange = currentIndex + 1;
    let revertIndex = null;
    if (willChange >= totalCount + 1) {
      currentIndex = willChange;
      revertIndex = 1;
    } else {
      currentIndex = willChange;
    }
    animateSwitchTo(currentIndex, revertIndex);
    if(revertIndex !== null) {
      currentIndex = 1;
    }
  }

  // 切换到上一个
  function switchToPrev() {
    if(isAnimating) {
      return;
    }
    setAutoPlay();
    const willChange = currentIndex - 1;
    let revertIndex = null;
    if (willChange <= 0) {
      currentIndex = willChange;
      revertIndex = totalCount;
    } else {
      currentIndex = willChange;
    }
    console.log(currentIndex, revertIndex);
    animateSwitchTo(currentIndex, revertIndex);

    if(revertIndex !== null) {
      currentIndex = totalCount;
    }
  }

  /** 动画切换到index 通过slider-in */
  function animateSwitchTo(index, revertIndex) {
    isAnimating = true;
    const tl = gsap.timeline();

    tl.to($list, {
      x: `-${index * 100}%`,
      duration: 0.5,
      ease: 'power1.out',
    });
    if(revertIndex !== null) {
      // 立刻切换到revertIndex
      tl.set($list, {
        x: `-${revertIndex * 100}%`,
      });
      switchIndicator(revertIndex);
    } else {
      // 切换indicator
      switchIndicator(index);
    }
    tl.call(() => {
      isAnimating = false;
    });
    tl.addLabel("start-title-animate");
    
    const startTitleAnimate = ($targetItem) => {
      // 获取title desc buttons
      const $title = $targetItem.find('.gallery-hero-item-title');
      const $desc = $targetItem.find('.gallery-hero-item-description');
      const $buttons = $targetItem.find('.gallery-hero-item-buttons');
      // 获取data-delay
      const titleDelay = $title.attr('data-delay');
      const descDelay = $desc.attr('data-delay');
      const buttonsDelay = $buttons.attr('data-delay');

      // 设置fromTo动画
      if($title.length > 0){
        tl.fromTo($title, // 起始状态
          { opacity: 0, y: '50%'}, 
          // 结束状态
          { 
            y: '0',
            opacity: 1, 
            duration: 1,
            delay: titleDelay,
            ease: "power4.out"
          }, "start-title-animate")  
      }

      // 描述
      if($desc.length > 0){
        tl.fromTo($desc,  // 起始状态
          { opacity: 0, y: '50%'}, 
          // 结束状态
          { 
            y: '0',
            opacity: 1, 
            duration: 1,
            delay: descDelay,
            ease: "power4.out"
          },
          "start-title-animate")
      }
      // 按钮
      if($buttons.length > 0){
        tl.fromTo($buttons,  
          // 起始状态
          { opacity: 0, y: '50%'}, 
          // 结束状态
          { 
            y: '0',
            opacity: 1, 
            duration: 0.9,
            delay: buttonsDelay,
            ease: "power4.out"
          },
          "start-title-animate"
        );
      }
    }


    //找到将要切换到的items
    const $targetItem = $list.find(`.gallery-hero-item`).eq(index);
    startTitleAnimate($targetItem);
    if (revertIndex !== null) {
      const $targetItem = $list.find(`.gallery-hero-item`).eq(revertIndex);
      startTitleAnimate($targetItem);
    }
  }

  const onIndicatorClick = (event) => {
    // 获取indicator上的data-index
    const index = $(event.target).attr('data-index');
    setAutoPlay();
    // 切换到index
    animateSwitchTo(index, null);
  }

  const setTouch = () => {
    // 使用gsap的Observe
    Observer.create({
      target: '.gallery-hero-outter', // can be any element (selector text is fine)
      type: "touch", // comma-delimited list of what to listen for
      onLeft: () => {
        if(isAnimating) return;
        setAutoPlay();
        switchToNext();
      },
      onRight: () => {
        if(isAnimating) return;
        setAutoPlay();
        switchToPrev();
      },
      tolerance: 50,
      preventDefault: false
    });
  }

  const setAutoPlay = () => {
    // 每次手动切换后都重置自动播放时间
    if (autoPlayTimer) {
      clearInterval(autoPlayTimer);
    }
    autoPlayTimer = setInterval(() => {
      switchToNext();
    }, 5000);
  }


  const init = () => {
    // 如果只有一个就不用处理了
    if (totalCount <= 1) {
      return;
    }
    // items初始化 复制第一个和最后一个放在最左和最右达成无限循环
    const $firstItem = $items.first().clone();
    const $lastItem = $items.last().clone();
    $list.append($firstItem);
    $list.prepend($lastItem);

    // indicator 初始化
    const $indicatorTemp = $indicatorContainer.find('.gallery-hero-indicator');
    // $indicatorContainer 清空
    $indicatorContainer.empty();
    // 复制
    for (let i = 0; i < totalCount; i++) {
      const $indicator = $indicatorTemp.clone();
      $indicatorContainer.append($indicator);
      // 增加一个data-index
      $indicator.attr('data-index', i + 1);
      // 增加点击事件
      $indicator.on('click', onIndicatorClick);
    }

    // 设置按钮
    if ($leftNav) {
      $leftNav.on('click', () => {
        setAutoPlay();
        switchToPrev();
      });
    }
    if ($rightNav) {
      $rightNav.on('click', () => {
        setAutoPlay();
        switchToNext();
      });
    }

    // 这样index的范围增加了两个，初始值是从1开始
    currentIndex = 1;
    gsap.set($list, {
      x: `-${currentIndex * 100}%`,
    });
    switchIndicator(currentIndex);

    // 每次手动切换后都重置自动播放时间
    setAutoPlay();

    // 增加触摸滑动设置
    setTouch();
  }

  init();
  
}



document.addEventListener("DOMContentLoaded", (event) => {
  // 检测移动端
  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  // const $gameScreenImgs = $('.game_gallery_hero_image');
  // for(let i = 0; i < $gameScreenImgs.length; i++){
  //   const ele = $gameScreenImgs[i];
  //   const imgUrl = ele.getAttribute('data-img');
  //   const mobileImgUrl = ele.getAttribute('data-img-mobile');
  //   ele.src = imgUrl;
  //   if(isMobile){
  //       ele.src = mobileImgUrl;
  //   }
  // }

  setupScreenAnimate();
});

//页面卸载
// window.addEventListener('unload', function() {
//   // 清除定时器
//   clearInterval(autoPlayTimer);
// });
